<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{ $route.meta.title }}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户职业信息审核列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="ID"
                        prop="id">
            <el-input v-model="search.id"
                      placeholder="请输入ID"
                      class="width-max"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="用户ID"
                        prop="userid">
            <el-input v-model="search.userid"
                      placeholder="请输入用户ID"
                      class="width-max"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="用户手机号"
                        prop="cellphone">
            <el-input v-model="search.cellphone"
                      placeholder="请输入用户手机号"
                      class="width-max"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="状态"
                        prop="status">
            <el-select v-model="search.status"
                       placeholder="请选择状态"
                       class="width-max"
                       clearable>
              <el-option v-for="(label, value) in workInfoStatus"
                         :key="value"
                         :label="label"
                         :value="value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="更新时间"
                        prop="updated_at">
            <el-date-picker
              v-model="search.updated_at"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              class="width-max"
              align="right">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索</el-button>
          <el-button icon="el-icon-refresh-left"
                     @click="onResetSearch()">重置</el-button>
          <el-button icon="el-icon-download"
                     @click="exportUserAuditWorkInfo()">按搜索结果导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-dropdown split-button
                     type="primary"
                     size="small"
                     icon="el-icon-remove-outline"
                     @click="onClickUploader"
                     trigger="click">
          批量驳回
          <el-upload ref="batchRejectUploader"
                     style="display: none"
                     action=""
                     accept=".xlsx"
                     :http-request="uploadBatchRejectFile"
                     :show-file-list="false"/>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-download" @click.native="downloadBatchRejectDemo">下载Demo文件</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown split-button
                     type="primary"
                     size="small"
                     icon="el-icon-remove-outline"
                     @click="onClickExpireUploader"
                     trigger="click">
          批量过期
          <el-upload ref="batchExpireUploader"
                     style="display: none"
                     action=""
                     accept=".xlsx"
                     :http-request="uploadBatchExpireFile"
                     :show-file-list="false"/>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-download" @click.native="downloadBatchExpireDemo">下载Demo文件</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row>
        <template v-for="attr of fields">
          <el-table-column v-if="attr.prop === 'status_cn'" v-bind="attr" :key="`${attr.prop}-tag`">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.status)">
                {{ scope.row.status_cn }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column v-else-if="attr.prop === 'workinfo_passed_times'" v-bind="attr" :key="attr.prop">
            <template slot-scope="scope">
              {{ scope.row.workinfo_passed_times && scope.row.workinfo_passed_times > 0 ? scope.row.workinfo_passed_times : '' }}
            </template>
          </el-table-column>
          <el-table-column v-else v-bind="attr" :key="attr.prop"></el-table-column>
        </template>

        <el-table-column fixed="right"
                         label="操作"
                         width="220px">
          <template slot-scope="scope">
            <div class="operation-buttons">
              <router-link :to="`/user-workinfo/detail/${scope.row.id}`">
                <el-button type="primary"
                           size="mini"
                           icon="el-icon-view"
                           class="margin b5">查看
                </el-button>
              </router-link>
              <router-link v-if="scope.row.status + '' === '0'"
                           :to="`/user-workinfo/audit/${scope.row.id}`">
                <el-button type="success"
                           size="mini"
                           icon="el-icon-check"
                           class="margin b5">审核
                </el-button>
              </router-link>
              <el-button type="danger"
                         size="mini"
                         icon="el-icon-close"
                         class="margin b5"
                         v-if="scope.row.status + '' === '1'"
                         @click="onReject(scope.row)">驳回
              </el-button>
              <el-button type="warning"
                         size="mini"
                         icon="el-icon-refresh"
                         class="margin b5"
                         v-if="scope.row.status + '' === '2'"
                         @click="onResetToWaitAudit(scope.row)">重置待审核
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../user-workinfo.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'
import { removeEmptyParams } from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        userid: null,
        cellphone: null,
        status: null,
        updated_at: [],
      },
      searchFieldType: {
        current_page: Number,
        per_page: Number,
      },
    }
  },
  computed: Vuex.mapState({
    workInfoStatus: state => state.userWorkInfo.workInfoStatus,
    fields: state => state.userWorkInfo.fields
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getUserWorkInfoTable', params)
    },

    onResetSearch () {
      this.resetSearch()
      this.onSearch({})
    },

    getStatusTagType (status) {
      const statusMap = {
        0: 'warning', // 待审核 - 橙色
        1: 'success', // 审核通过 - 绿色
        2: 'danger' // 审核未通过 - 红色
      }
      return statusMap[status] || 'info'
    },
    downloadBatchRejectDemo () {
      this.$export('批量驳回职业信息Demo', [
        {
          'userid': '10000',
          'failed_reason': '证件照不清晰',
        },
        {
          'userid': '10001',
          'failed_reason': '工种选择异常',
        }
      ], {
        fileHeader: [
          { key: 'userid', text: '用户ID' },
          { key: 'failed_reason', text: '不通过原因' },
        ]
      })
    },
    downloadBatchExpireDemo () {
      this.$export('批量过期职业信息Demo', [
        {
          'userid': '10000',
        },
      ], {
        fileHeader: [
          { key: 'userid', text: '用户ID' },
        ]
      })
    },
    onClickExpireUploader (e) {
      e.stopPropagation()
      this.$refs['batchExpireUploader'].$refs['upload-inner'].handleClick()
    },
    uploadBatchExpireFile (file) {
      let isLt10M = file.file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        return false
      }

      let formData = new FormData()
      formData.append('file', file.file)

      request.common('batchExpireWorkInfoApi', formData).then(({data}) => {
        this.$confirm('任务创建成功, 是否前往批量任务列表页面查看？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/users/batch/table'})
        })
      })
    },
    onClickUploader (e) {
      e.stopPropagation()
      this.$refs['batchRejectUploader'].$refs['upload-inner'].handleClick()
    },
    uploadBatchRejectFile (file) {
      let isLt10M = file.file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        return false
      }

      let formData = new FormData()
      formData.append('file', file.file)

      request.common('batchRejectWorkInfoApi', formData).then(({data}) => {
        this.$confirm('任务创建成功, 是否前往批量任务列表页面查看？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/users/batch/table'})
        })
      })
    },
    exportUserAuditWorkInfo () {
      this.$confirm('是否按搜索条件导出用户职业信息数据？', '提示', {type: 'warning'}).then(() => {
        request.common('exportUserAuditWorkInfoApi', removeEmptyParams(_.cloneDeep(this.search))).then(({data}) => {
          this.$confirm('任务创建成功, 是否前往批量任务列表页面查看？', '提示', {type: 'success'}).then(() => {
            this.$router.push({path: '/users/batch/table'})
          })
        })
      })
    },
    // 驳回，驳回原因必须填写
    onReject (row) {
      this.$prompt('请填写驳回原因', '提示', {
        type: 'warning',
        inputPattern: /^\S+$/,
        inputErrorMessage: '请填写驳回原因',
      }).then(async ({value}) => {
        const auditForm = {
          id: row.id,
          updated_at: row.updated_at,
          is_rejected: 1,
          failed_reason: value,
        }
        await request.common('auditUserWorkInfoData', auditForm)
        this.$message.success('驳回成功')
        this.onSearch()
      })
    },
    // 重置回待审核状态
    onResetToWaitAudit (row) {
      this.$confirm('是否将状态重置回待审核？', '提示', {type: 'warning'}).then(async () => {
        const params = {id: row.id, updated_at: row.updated_at, is_rejected: 0, reset_to_wait_audit: 1}
        await request.common('auditUserWorkInfoData', params)
        this.$message.success(`数据(${row.id})重置回待审核成功`)
        this.onSearch()
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.table-panel {
  margin-bottom: 20px;
}

.operation-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
}

.operation-buttons .el-button {
  margin: 0;
  min-width: 60px;
}

.operation-buttons .margin.b5 {
  margin-bottom: 5px;
}

/* 美化表格状态显示 */
.el-tag {
  font-weight: 500;
}

/* 美化表格状态显示 */
.el-tag {
  font-weight: 500;
}

/* 美化下拉菜单 */
.el-dropdown-menu__item {
  padding: 8px 16px;
  font-size: 14px;
}

/* 美化面包屑导航 */
.page-heading {
  .el-breadcrumb {
    margin-top: 8px;
    font-size: 14px;
  }
}

/* 美化表单项间距 */
.re-el-form__flex .el-form-item {
  margin-bottom: 20px;
}

/* 美化操作按钮区域 */
.el-table {
  .el-button--mini {
    padding: 7px 12px;
    font-size: 12px;

    &.el-button--primary {
      background: linear-gradient(135deg, #409EFF, #66b1ff);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #66b1ff, #409EFF);
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      }
    }

    &.el-button--success {
      background: linear-gradient(135deg, #67C23A, #85ce61);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #85ce61, #67C23A);
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
      }
    }

    &.el-button--danger {
      background: linear-gradient(135deg, #F56C6C, #f78989);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #f78989, #F56C6C);
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
      }
    }

    &.el-button--warning {
      background: linear-gradient(135deg, #E6A23C, #ebb563);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #ebb563, #E6A23C);
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(230, 162, 60, 0.3);
      }
    }

    &:active {
      transform: translateY(0);
    }
  }
}

/* 美化无边框表格样式 */
.el-table {
  border: none !important;

  &::before {
    height: 0 !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
      th {
        border-bottom: 2px solid #e8e8e8 !important;
        background-color: #fafafa !important;
        color: #333 !important;
        font-weight: 600 !important;
      }
    }
  }

  .el-table__body-wrapper {
    .el-table__body {
      tr {
        border-bottom: 1px solid #f0f0f0 !important;

        &:last-child {
          border-bottom: none !important;
        }

        &:hover {
          background-color: #f8f9fa !important;
        }
      }
    }
  }

  td {
    border: none !important;
  }

  th {
    border: none !important;
  }
}

/* 美化分页 */
.pagination {
  margin-top: 20px;
  text-align: center;

  .el-pagination {
    padding: 20px 0;
    display: inline-block;
  }
}

/* 美化面板 */
.layout-panel {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .el-card__header {
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    border-bottom: 1px solid #dee2e6;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user-workinfo/pages/UserWorkInfoTable.vue